/* eslint-disable no-restricted-syntax */

import dayjs from 'dayjs';
import { TIME_FORMAT_UTC_OFFSET_TIMEZONE, DATE_TIME_SLASH } from '../dates';

class CSVFaultCodeStrategy {
  constructor() {
    this.farmMap = {};
    this.lineMap = {};

    const timeZoneString = dayjs.tz().format(TIME_FORMAT_UTC_OFFSET_TIMEZONE);
    this.csvLines = [
      [
        'Farm Name',
        'Line Name',
        `Start ${timeZoneString} (${DATE_TIME_SLASH.toLowerCase()})`,
        `End ${timeZoneString} (${DATE_TIME_SLASH.toLowerCase()})`,
        'Start Epoch (s)',
        'End Epoch (s)',
        'Fault Type',
        'Duration',
        'No Feed Seconds',
        'Fault Root Cause',
        'Fault Comment',
        'Animal Group\n',
      ].join(', '),
    ];
  }

  setFarmObjects = (farms) => {
    farms.forEach((f) => {
      this.farmMap[f.id] = f.name;
      f.feed_lines.forEach((l) => {
        this.lineMap[l.id] = l.name;
      });
    });
  };

  processFaultCodes = (farmId, lineId, dataArray) => {
    const farmName = this.farmMap[farmId];
    const lineName = this.lineMap[lineId];
    dataArray.forEach((d) => {
      this.csvLines.push(
        [
          `${farmName}`,
          `${lineName}`,
          `${dayjs.tz(1000 * d.s).format(DATE_TIME_SLASH)}`,
          `${d.e !== null ? dayjs.tz(1000 * d.e).format(DATE_TIME_SLASH) : ''}`,
          `${d.s}`,
          `${d.e !== null ? d.e : ''}`,
          `${d.faultText}`,
          `${d.duration ? d.duration : ''}`,
          `${d.nofeedSeconds ? d.nofeedSeconds : ''}`,
          `${d.rootCause ? d.rootCause : ''}`,
          `${d.faultComment ? d.faultComment : ''}`,
          `${d.animalGroup ? d.animalGroup : ''}\n`,
        ].join(', '),
      );
    });
  };

  createFile = () => {
    const toWrite = this.csvLines;
    this.csvLines = null;
    return new Blob(toWrite, { type: 'text/csv' });
  };
}
export default CSVFaultCodeStrategy;
